import type { JSX } from 'react';
import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { ExperienceFormData } from './ExperienceFormFields';

interface ExperienceDateFieldsProps {
  register: UseFormRegister<ExperienceFormData>;
  errors: FieldErrors<ExperienceFormData>;
  isOngoing: boolean;
}

export function ExperienceDateFields({
  register,
  errors,
  isOngoing,
}: ExperienceDateFieldsProps): JSX.Element {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label>Start Date</Label>
        <div className="flex gap-2">
          <Input
            {...register('startYear')}
            placeholder="Year"
            type="number"
            min="1900"
            max="2100"
          />
          <Input {...register('startMonth')} placeholder="Month" type="number" min="1" max="12" />
        </div>
      </div>
      <div className="space-y-2">
        <Label>End Date</Label>
        <div className="flex gap-2">
          <Input
            {...register('endYear')}
            placeholder="Year"
            type="number"
            min="1900"
            max="2100"
            disabled={isOngoing}
          />
          <Input
            {...register('endMonth')}
            placeholder="Month"
            type="number"
            min="1"
            max="12"
            disabled={isOngoing}
          />
        </div>
        {errors.endYear && (
          <span className="text-sm text-destructive">{errors.endYear.message}</span>
        )}
      </div>
    </div>
  );
}
